import type { NumberOptions } from "@/react/components/shared/ProfileFields/FormFields/CustomField/NumberInput";
import { NUMERIC_FORMATS } from "@/react/components/shared/ProfileFields/constants";
import { getCurrentBcp47Locale } from "../localeHelpers";

export const formattedNumber = (
  value: number,
  options: NumberOptions,
): string => {
  const { format, decimal = 0, position, text } = options;

  // For unformatted numbers, return the value as is
  if (format === NUMERIC_FORMATS.UNFORMATTED) {
    return value.toString();
  }

  const currentBcp47Locale = getCurrentBcp47Locale();
  // Format number with thousand separators and decimal places, `toLocaleString` from circle is not adding the necessary decimals
  let formattedValue = value.toLocaleString(currentBcp47Locale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  });

  // Add percentage symbol for percentage format
  if (format === NUMERIC_FORMATS.PERCENT) {
    formattedValue += "%";
  }

  // Add custom text prefix/suffix for custom format
  if (format === NUMERIC_FORMATS.CUSTOM && text) {
    formattedValue =
      position === "left"
        ? `${text} ${formattedValue}`
        : `${formattedValue} ${text}`;
  }

  return formattedValue;
};
